export default __webpack_public_path__ + "static/media/823.7c41b08f.png";